import { render, staticRenderFns } from "./HorizontalNavMenuLink.vue?vue&type=template&id=621944e6&"
import script from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavMenuLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports